(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dabwell-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dabwell-story')) {
  customElements.define('dabwell-story', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;

      this.addEventListener('input', e => {
        if (e.target.matches('[data-dw-compare]')) {
          e.target.closest('.dw-compare').style.setProperty(
            '--dw-reveal',
            e.target.value + '%'
          );
        }
      }, { signal });

      this.addEventListener('click', e => {
        const scroll = e.target.closest('[data-dw-scroll]');
        if (scroll) {
          const track = scroll.closest('.dw-module').querySelector('.dw-story-track');
          track.scrollBy({
            left: track.clientWidth * Number(scroll.dataset.dwScroll),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }

        const purchase = e.target.closest('[data-dw-purchase]');
        if (purchase) {
          let target;
          try {
            target = document.querySelector(this.dataset.purchaseSelector);
          } catch {}

          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              block: 'center',
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });

            const control = target.querySelector(
              'button[type="submit"],input:not([type="hidden"]),select'
            );
            if (control) control.focus({ preventScroll: true });
          }
        }
      }, { signal });

      this.querySelectorAll('[data-dw-tabs]').forEach(group => {
        const buttons = [...group.querySelectorAll('[data-dw-tab]')];
        const panels = [...group.querySelectorAll('[data-dw-panel]')];
        if (!buttons.length) return;

        group.querySelector('.dw-tab-buttons').setAttribute('role', 'tablist');
        group.querySelector('.dw-tab-buttons').setAttribute(
          'aria-label',
          group.closest('.dw-module').querySelector('h2')?.textContent || 'Benefits'
        );

        const activate = button => {
          buttons.forEach(b => {
            const active = b === button;
            b.setAttribute('aria-selected', String(active));
            b.tabIndex = active ? 0 : -1;
          });

          panels.forEach(p => {
            p.hidden = p.dataset.dwPanel !== button.dataset.dwTab;
            if (p.hidden) p.querySelectorAll('video').forEach(v => v.pause());
          });
        };

        buttons.forEach((button, index) => {
          button.setAttribute('role', 'tab');
          button.addEventListener('click', () => activate(button), { signal });

          button.addEventListener('keydown', e => {
            let next = index;
            if (e.key === 'ArrowRight') next = (index + 1) % buttons.length;
            else if (e.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = buttons.length - 1;
            else return;

            e.preventDefault();
            activate(buttons[next]);
            buttons[next].focus();
          }, { signal });
        });

        panels.forEach(p => {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute(
            'aria-labelledby',
            buttons.find(b => b.dataset.dwTab === p.dataset.dwPanel).id
          );
          p.tabIndex = 0;
        });

        activate(buttons[0]);
      });

      document.addEventListener('shopify:block:select', e => {
        const block = this.querySelector(
          '[data-shopify-editor-block*="' + e.detail.blockId + '"]'
        );
        if (block) block.scrollIntoView({ block: 'center' });
      }, { signal });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
